module.exports = __webpack_public_path__ + "static/media/ic_cast.5a665101.png";